<template>
    <div class="corwin-nav">
        <el-menu
            :default-active.sync="activeLink"
            :mode="mode"
            @select="goto"
            :collapse="isCollapse"
            :unique-opened="true"
            background-color="transparent"
            class="main-navigation-menu"
            :class="{ 'nav-collapsed': isCollapse }"
        >
            <div class="el-menu-item-group__title">
                <span>Main Menu</span>
            </div>
            <template v-if="hasRole(Roles.MAIN_ROLES) && !current_corporation">
                <el-menu-item
                    index="/home/corporations"
                    v-if="hasRoutePermission(Routes.CORPORATIONS)"
                >
                    <i class="mdi mdi-city"></i>
                    <span slot="title">Corporations</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/communities"
                    v-if="hasRoutePermission(Routes.COMMUNITIES)"
                >
                    <i class="mdi mdi-account-group"></i>
                    <span slot="title">Communities</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/users"
                    v-if="hasRoutePermission(Routes.USERS)"
                >
                    <i class="mdi mdi-account-multiple"></i>
                    <span slot="title">Users</span>
                </el-menu-item>
            </template>

            <template
                v-if="
                    hasRole(Roles.MAIN_ROLES) &&
                    !current_community &&
                    !current_corporation
                "
            >
                <div class="el-menu-item-group__title">
                    <span>Orders</span>
                </div>
                <el-menu-item
                    index="/home/orders/dashboard"
                    v-if="hasRoutePermission(Routes.ORDER_DASHBOARD)"
                >
                    <i class="mdi mdi-view-dashboard"></i>
                    <span slot="title">Dashboard</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/orders/pending"
                    v-if="hasRoutePermission(Routes.PENDING_ORDERS)"
                >
                    <i class="mdi mdi-cart"></i>
                    <span slot="title">Pending Orders</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/orders/hub"
                    v-if="hasRoutePermission(Routes.ORDER_HUB)"
                >
                    <i class="mdi mdi-basket"></i>
                    <span slot="title">Order Hub</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/orders/closed"
                    v-if="hasRoutePermission(Routes.CLOSED_ORDERS)"
                >
                    <i class="mdi mdi-clipboard-check"></i>
                    <span slot="title">Closed Orders</span>
                </el-menu-item>
            </template>

            <template
                v-if="
                    hasRole(Roles.MAIN_ROLES) &&
                    !current_corporation &&
                    !current_community
                "
            >
                <div class="el-menu-item-group__title">
                    <span>Content</span>
                </div>
                <el-menu-item
                    index="/home/filler-articles"
                    v-if="hasRoutePermission(Routes.FILLER_ARTICLES)"
                >
                    <i class="mdi mdi-newspaper"></i>
                    <span slot="title">Filler Articles</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/themes"
                    v-if="hasRoutePermission(Routes.THEMES)"
                >
                    <i class="mdi mdi-drawing-box"></i>
                    <span slot="title">Calendar Themes</span>
                </el-menu-item>
            </template>

            <!--Community Routes-->
            <template v-if="current_community">
                <el-menu-item
                    index="/home/dashboard"
                    v-if="hasRoutePermission(Routes.DASHBOARD)"
                >
                    <i class="mdi mdi-home"></i>
                    <span slot="title">Home</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/cart"
                    v-if="hasRoutePermission(Routes.CART)"
                >
                    <i class="mdi mdi-cart"></i>
                    <span slot="title">Shopping Cart</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/orders"
                    v-if="hasRoutePermission(Routes.ORDERS)"
                >
                    <i class="mdi mdi-history"></i>
                    <span slot="title">Order History</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/proofs"
                    v-if="
                        hasRoutePermission(Routes.NEWS_PROOFS) &&
                        CheckNewsProofs()
                    "
                >
                    <img
                        src="/images/dashboard/icon_check.svg"
                        class="check-img-nav"
                    />
                    <span slot="title">News Proofs</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/digital-display"
                    v-if="hasRoutePermission(Routes.DIGITAL_DISPLAY)"
                >
                    <i class="mdi mdi-laptop-chromebook"></i>
                    <span slot="title">Digital Display</span>
                </el-menu-item>
            </template>

            <template v-if="current_corporation">
                <el-menu-item
                    index="/home/communities"
                    v-if="hasRoutePermission(Routes.COMMUNITIES)"
                >
                    <i class="mdi mdi-account-group"></i>
                    <span slot="title">Communities</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/users"
                    v-if="hasRoutePermission(Routes.USERS)"
                >
                    <i class="mdi mdi-account-multiple"></i>
                    <span slot="title">Users</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/orders"
                    v-if="hasRoutePermission(Routes.ORDERS)"
                >
                    <i class="mdi mdi-basket"></i>
                    <span slot="title">Orders</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/announcements"
                    v-if="hasRoutePermission(Routes.ANNOUNCEMENTS)"
                >
                    <i class="mdi mdi-bullhorn"></i>
                    <span slot="title">Announcements</span>
                </el-menu-item>
            </template>

            <div class="el-menu-item-group__title">
                <span>Settings</span>
            </div>
            <template v-if="hasRole(Roles.MAIN_ROLES)">
                <el-menu-item
                    index="/home/settings/pricing"
                    v-if="hasRoutePermission(Routes.PRICING)"
                >
                    <i class="mdi mdi-currency-usd"></i>
                    <span slot="title">Pricing</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/settings/early-bird"
                    v-if="hasRoutePermission(Routes.EARLY_BIRD)"
                >
                    <i class="mdi mdi-twitter"></i>
                    <span slot="title">Early Bird</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/settings/holiday"
                    v-if="hasRoutePermission(Routes.HOLIDAY)"
                >
                    <i class="mdi mdi-notebook"></i>
                    <span slot="title">Holiday</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/settings/shipping"
                    v-if="hasRoutePermission(Routes.SETTINGS)"
                >
                    <i class="mdi mdi-truck-delivery"></i>
                    <span slot="title">Shipping</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/sage"
                    v-if="hasRoutePermission(Routes.SAGE)"
                >
                    <i class="mdi mdi-notebook"></i>
                    <span slot="title">Sage</span>
                </el-menu-item>
                <el-menu-item
                    index="/home/settings/notification"
                    v-if="hasRoutePermission(Routes.NOTIFICATION_SETTINGS)"
                >
                    <i class="mdi mdi-bell"></i>
                    <span slot="title">Notifications</span>
                </el-menu-item>
            </template>
            <el-menu-item
                index="/home/settings/account"
                v-if="hasRoutePermission(Routes.ACCOUNT_DETAILS)"
            >
                <i class="mdi mdi-account-circle"></i>
                <span slot="title">My Account</span>
            </el-menu-item>
            <el-menu-item
                index="/home/settings/event-logs"
                v-if="hasRoutePermission(Routes.EVENT_LOGS)"
            >
                <i class="mdi mdi-calendar"></i>
                <span slot="title">Event Logs</span>
            </el-menu-item>
            <el-menu-item @click="help()">
                <i class="mdi mdi-help-circle" />
                <span slot="title">Help</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
import { detect } from "detect-browser";
import { mapGetters, mapState } from "vuex";
import * as Roles from "../constants/roles";
import auth_mixin from "../mixins/auth";
import * as Routes from "./../constants/routes";
import { getRoutesUtil } from "./../utils/routes.default";
const browser = detect();

export default {
    name: "Nav",
    props: ["mode", "isCollapse"],
    mixins: [auth_mixin],
    data() {
        return {
            Roles,
            Routes,
            isIe: true,
            isEdge: true,
            activeLink: null,
            isNavigating: false,
            routes_util: null
        };
    },
    created() {
        if (browser && browser.name !== "ie") this.isIe = false;
        if (browser && browser.name !== "edge") this.isEdge = false;

        this.setLink(this.$router.currentRoute.path);
        this.$router.afterEach((to, from) => {
            this.setLink(this.$router.currentRoute.path);
        });
        // Initialize routes_util with the current router instance
        this.routes_util = getRoutesUtil(this.$router);
    },
    mounted() {
        this.updateNavItemsUnderLine();
    },
    computed: {
        ...mapState(["current_community", "current_corporation"]),
        ...mapGetters(["calendarEnabled", "newsletterEnabled"])
    },
    methods: {
        goto(index, indexPath) {
            if (!index || this.isNavigating) {
                return;
            }

            if (index.charAt(0) === "/") {
                // Set flag to prevent multiple rapid navigations
                this.isNavigating = true;

                // Emit event and navigate once
                this.$emit("push-page", { page: index });

                this.$nextTick(() => {
                    this.updateNavItemsUnderLine();

                    this.$router
                        .push(index)
                        .catch((err) => {
                            if (
                                err.name !== "NavigationDuplicated" &&
                                !err.message.includes(
                                    "Avoided redundant navigation to current location"
                                )
                            ) {
                                console.error("Navigation error:", err);
                            }
                        })
                        .finally(() => {
                            // Reset navigation flag with slight delay to prevent rapid clicks
                            setTimeout(() => {
                                this.isNavigating = false;
                            }, 300);
                        });
                });
            }
        },
        setLink(path) {
            this.activeLink = path;
        },
        updateNavItemsUnderLine() {
            this.$nextTick(() => {
                let menu_items = $(".el-menu-item");
                _.forEach(menu_items, (menu_item) => {
                    let span = $(menu_item).children("span");
                    $(menu_item).addClass(`el-menu-item-${span.width()}`);
                    let c = `el-menu-item-${span.width()}`;
                    $(menu_item).append(
                        `<style>.${c}:hover:before{width: ${span.width()}px !important;}</style>`
                    );
                });
            });
        },
        isRouteAccessible(name) {
            return this.routes_util && this.routes_util.isRouteAccessible(name);
        },
        help() {
            window.open("https://corwindesign.com/help/", "_blank");
        },
        CheckNewsProofs() {
            if (
                this.newsletterEnabled &&
                this.current_community.newsletter_pdf_order
            ) {
                return true;
            }
            return false;
        },
        hasRoutePermission(routeName) {
            return (
                this.routes_util &&
                this.routes_util.hasRoutePermission(routeName)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.el-menu {
    border: none;
}

.el-menu::before,
.el-menu::after {
    display: none;
}

.el-submenu,
.el-menu-item {
    .mdi {
        vertical-align: middle;
        margin-right: 5px;
        display: inline-block;
        width: 24px;
        text-align: center;
        font-size: 18px;
    }
}
</style>

<style lang="scss">
@use "sass:color";
@import "../../assets/scss/variables";

.main-navigation-menu {
    transition: width 0.5s;

    &:not(.el-menu--collapse) {
        .el-submenu__title,
        .el-menu-item {
            height: 40px;
            line-height: 40px;
            background-color: transparent !important;
        }

        &:not(.el-menu--horizontal) {
            .el-menu-item,
            .el-submenu {
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    width: 0px;
                    height: 1px;
                    position: absolute;
                    bottom: 10px;
                    left: 30px;
                    background: $text-color;
                    z-index: 1;
                    opacity: 0;
                    transition: all 0.7s cubic-bezier(0.55, 0, 0.1, 1);
                }

                &:hover {
                    &::before {
                        width: 100px;
                        opacity: 1;
                        //left: 50px;
                        transform: translate(20px, 0);
                    }
                }

                &.is-active {
                    &::before {
                        background: $text-color-accent;
                    }
                }
            }
        }

        .el-submenu.is-opened {
            //background: #edf1f6 !important;
            //background: rgba(223, 228, 234, 0.38) !important;
            position: relative;

            &::after {
                content: "";
                display: block;
                width: 2px;
                position: absolute;
                top: 40px;
                bottom: 10px;
                left: 31px;
                background: $text-color;
                z-index: 1;
            }

            &::before {
                display: none;
            }

            .el-menu-item,
            .el-submenu {
                &::before,
                &::after {
                    display: none;
                }
            }
        }

        .el-menu-item-group__title {
            padding: 15px 0 0px 20px;
            color: white;
        }
    }

    .el-submenu__title,
    .el-menu-item:not(.is-active) {
        color: $text-color;

        i {
            color: $text-color;
        }
    }

    &.el-menu--collapse {
        .el-menu-item-group__title {
            padding: 15px 0 0px 0px;
            width: 100%;
            text-align: center;
            color: white;
        }

        .el-submenu__title:hover,
        .el-menu-item:hover {
            background-color: rgba(0, 0, 0, 0.05) !important;
        }
    }

    &.el-menu--horizontal {
        white-space: nowrap;
        /*width: fit-content;
                width: max-content;*/
        overflow: hidden;
        display: table;

        & > * {
            float: inherit !important;
            display: inline-block;
        }
    }

    &.nav-collapsed {
        .el-menu-item,
        .el-submenu__title {
            & > span {
                display: none;
            }
        }
    }
}

.main-navigation-submenu {
    .el-menu {
        background: #fff !important;

        .el-menu-item:not(.is-active) {
            color: $text-color;
        }

        .el-menu-item:hover {
            background-color: color.adjust($background-color, $alpha: -0.7) !important;
        }
    }
}

.el-menu-item-group__title {
    font-size: 0.9rem;
}
.check-img-nav {
    height: 30px;
}
</style>
